export default {
	main: {
		site_id: 1138,
		title: "Terminal PRO",
		websitePasswordHash: "1576def2905b8bf2ee8dd33e8b543dcc18952e83ac7efd3710af973ab8b250f7",
		staffPassword: "124578",
		availableLanguages: {
			"@replace": true,
			spa: {
				short: "ES",
				name: "Español",
				region: "UnitedKingdom",
				order: 2,
			},
			eng: {
				short: "EN",
				name: "English",
				region: "UnitedKingdom",
				order: 1,
			},
			por: {
				short: "PT",
				name: "Português",
				region: "Portugal",
				order: 5,
			},
		},
	},
	disableCashoutInHeader: true,
	disableCashoutAfterLogin: false,
	showBalanceWithoutLogin: false,
	cashoutMethods: [
		{
			pic: "pix.png",
			name: "pix",
			service: "PAYBROKERS",
			handlerPopup: "POPUPS.CASHOUT_BY_PIX",
			isAmountEditable: true,
		},
		{
			pic: "pix-safeway.png",
			name: "pix-safeway",
			service: "SAFEWAY",
			handlerPopup: "POPUPS.CASHOUT_BY_PIX",
			isAmountEditable: true,
		},
	],
	depositMethods: [
		{
			type: "pix",
			minAmount: 20,
			enabled: true,
		},
		{
			type: "pix_safeway",
			minAmount: 20,
			enabled: false,
		},
	],
	disableDepositAfterLogin: false,
	signInType: 'cpf',
	defaultTerminalParams: { pid: 18750659, tid: 30284, token: "Fb89DQ==", currency: "BRL" },
};
